import { render, staticRenderFns } from "./CancelBill.vue?vue&type=template&id=228725e9&"
import script from "./CancelBill.vue?vue&type=script&lang=js&"
export * from "./CancelBill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CancelBill.vue"
export default component.exports